import React, { useState } from "react";
import { HStack, Box, VisuallyHidden } from "@chakra-ui/react";
import { useField, useFormikContext } from "formik";
import { StarIcon } from "@chakra-ui/icons";

interface StarRatingProps {
  name: string;
  count: number;
}

const StarRating: React.FC<StarRatingProps> = ({ name, count }) => {
  const [hover, setHover] = useState<number | null>(null);

  const { setFieldValue, validateField } = useFormikContext();
  const [field] = useField(name);

  return (
    <HStack spacing={2} role="radiogroup" aria-label="Rating">
      {[...Array(count)].map((_, index) => {
        const ratingValue = index + 1;
        const isSelected = field.value === ratingValue;
        const isHighlighted = ratingValue <= (hover || field.value || 0);

        return (
          <Box
            key={index}
            as="button"
            type="button"
            role="radio"
            aria-checked={isSelected}
            aria-label={`${ratingValue} star${ratingValue !== 1 ? 's' : ''}`}
            color={isHighlighted ? "#ffc107" : "#e4e5e9"}
            onMouseEnter={() => setHover(ratingValue)}
            onMouseLeave={() => setHover(null)}
            onClick={() => {
              setFieldValue(name, ratingValue, false);
              validateField(name);
            }}
            cursor="pointer"
            background="transparent"
            border="none"
            padding={0}
            _focus={{
              outline: "2px solid #ffc107",
              outlineOffset: "2px"
            }}
          >
            <StarIcon
              fontSize="xl"
              transition="color 200ms"
              aria-hidden="true"
            />
          </Box>
        );
      })}
    </HStack>
  );
};

export default StarRating;